// @flow
import { connect } from 'react-redux'
import SegmentationPreview from './SegmentationPreview'
import type { Store } from '../../redux/ducks'
import { getAudienceEditSegments } from '../../redux/selectors/segmentation'

function mapStateToProps(state: Store) {
  const segmentationResult = getAudienceEditSegments(state)

  return {
    isSegmenting: segmentationResult.isSegmenting,
    segmentsCount: segmentationResult.count,
    segmentItems: segmentationResult.items,
    isLimitExceeded: segmentationResult.isLimitExceeded,
    maxSegmentsCount: segmentationResult.maxSegmentsCount
  }
}

const SegmentationPreviewContainer = connect<Object, Object, _, _, _, _>(mapStateToProps)(
  SegmentationPreview
)

export default SegmentationPreviewContainer
